/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerRetryMutationResponse, JobsControllerRetryPathParams, JobsControllerRetry400, JobsControllerRetry404 } from "../../models/jobsController/JobsControllerRetry";

function getJobsControllerRetryUrl(id: JobsControllerRetryPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/jobs/${id}/retry` as const }  
  return res
}

/**
 * @description Retry a job that is in a terminal state (FAILED, COMPLETED, CANCELED, OMITTED). The job is reset to QUEUED and re-enqueued. All downstream dependent jobs are reset to PENDING.
 * @summary Retry a job
 * {@link /api/v1/jobs/:id/retry}
 */
export async function jobsControllerRetry(id: JobsControllerRetryPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<JobsControllerRetryMutationResponse, ResponseErrorConfig<JobsControllerRetry400 | JobsControllerRetry404>, unknown>({ method : "POST", url : getJobsControllerRetryUrl(id).url.toString(), ... requestConfig })  
  return res.data
}